var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup38(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.591,
    height: 145.196,
    viewBox: "0 0 153.591 145.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(335.867 -1572.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M733.747,662.882h42.868A13.488,13.488,0,0,1,790.1,676.37v27.891a13.488,13.488,0,0,1-13.488,13.488H733.747a13.488,13.488,0,0,1-13.488-13.488V676.37a13.488,13.488,0,0,1,13.488-13.488",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M736.518,572.554h37.324a16.26,16.26,0,0,1,16.26,16.26V636.03a16.26,16.26,0,0,1-16.26,16.26H736.518a16.261,16.261,0,0,1-16.26-16.26V588.814a16.261,16.261,0,0,1,16.26-16.26",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M860.361,627.42H817.492a13.487,13.487,0,0,1-13.487-13.488V586.041a13.487,13.487,0,0,1,13.487-13.488h42.869a13.488,13.488,0,0,1,13.488,13.488v27.891a13.488,13.488,0,0,1-13.488,13.488",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M857.589,717.748H820.265a16.26,16.26,0,0,1-16.26-16.26V654.272a16.259,16.259,0,0,1,16.259-16.26h37.325a16.26,16.26,0,0,1,16.26,16.26v47.216a16.26,16.26,0,0,1-16.26,16.26",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup38);
export default __webpack_public_path__ + "static/media/Group 38.609035e9df90d0a827f32d28d917990f.svg";
export { ForwardRef as ReactComponent };